import {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios';
import swal from "sweetalert2";
import { exposeServerRenderError } from './serverRender';

/**
 * Charge un document public B2C (ticket, commande ou devis) sans authentification.
 * Généralisation du chargement utilisé par ticket_public : gère la variante d'URL simple
 * et la variante multi-tenant `{company}`, ainsi que les erreurs de validation et le 403 (→ 404 affiché).
 *
 * @param {string} path - Nom de la ressource sous api/pos/, ex: "ticket_public", "commande_public", "devis_public"
 * @param {string} company - UUID de société (variante multi-tenant), vide si non applicable
 * @param {number|string} id - ID du document (ticket, commande ou devis)
 * @param {string} token - Token de consultation (celui du ticket lié pour commande/devis)
 * @returns {[boolean, Object, boolean]} [loading, response (payload complet de la réponse valide), error404]
 */
const useLoadPublicDocument = (path, company, id, token) =>{
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [response,setResponse]=useState({})
    const [error404,setError404]=useState(false)

    useEffect(function () {
        (async function() {
            const urlCompany = (company && company!='') ? company+'/' : '';
            const resp = await axios.get(process.env.REACT_APP_API_URL+"api/pos/"+path+"/get_one/"+urlCompany+id+'/'+token
            ).then((resp) => {
                if(!resp.data.valid){
                    let interms='';
                    var keys = Object.keys(resp.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=resp.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    exposeServerRenderError(messageError)
                    swal.fire(messageError, "", "error");
                    setLoading(false)
                }else{
                    setResponse(resp.data)
                    setLoading(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                exposeServerRenderError(error.response ? 'HTTP '+error.response.status : error)
                if(error.response && error.response.status==403) setError404(true)
                swal.fire(t('unknowError'), "", "error");
                setLoading(false)
            })
        })()
    }, [])

    return [loading,response,error404]
}

export default useLoadPublicDocument;
